// This file was auto-generated by Fern from our API Definition.
export const SessionInteractionKind = {
    UserApproval: "user_approval",
    UserInput: "user_input",
    ClientTool: "client_tool",
};
